import type { TourStepConfig } from '@carboncopyco/types';
import { useEffect, useState } from 'react';

interface UseTourCaptureProps {
  originalTourId: string;
}

const useTourCapture = ({ originalTourId }: UseTourCaptureProps) => {
  const [stepConfigToInheritFrom, setStepConfigToInheritFrom] =
    useState<TourStepConfig | null>(null);

  useEffect(() => {
    const stepConfig = JSON.parse(
      localStorage.getItem(`stepConfigToInheritFrom-${originalTourId}`)
    ) as TourStepConfig;

    if (!stepConfig) {
      return;
    }

    delete stepConfig.tooltip.balloon.layout;

    setStepConfigToInheritFrom(stepConfig);
    localStorage.removeItem(`stepConfigToInheritFrom-${originalTourId}`);
  }, [originalTourId]);

  return {
    stepConfigToInheritFrom,
  };
};

export default useTourCapture;
